import "core-js/modules/es.object.get-own-property-descriptor";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import { lock } from '@/util/decorator';
import { request } from './util';
var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';
var MagicService = (_class = /*#__PURE__*/function () {
  function MagicService() {
    _classCallCheck(this, MagicService);
  }

  _createClass(MagicService, null, [{
    key: "hasBookAct",
    value: function hasBookAct() {
      var options = {
        type: 30,
        option: 3,
        act_id: '107475',
        module_id: '121453'
      };
      return request({
        retry: 1,
        jsonp: true
      })(baseUrl, options);
    }
  }, {
    key: "bookAct",
    value: function bookAct() {
      var options = {
        type: 30,
        option: 104,
        act_id: '107475',
        module_id: '121453'
      };
      return request()(baseUrl, options);
    }
  }]);

  return MagicService;
}(), (_applyDecoratedDescriptor(_class, "hasBookAct", [lock], Object.getOwnPropertyDescriptor(_class, "hasBookAct"), _class), _applyDecoratedDescriptor(_class, "bookAct", [lock], Object.getOwnPropertyDescriptor(_class, "bookAct"), _class)), _class);
export default MagicService;